import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTableFilterBoolean, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterSelect, LazyTableFilterString, LazyTableToolBotsCreate, LazyTableToolGeneralExport, LazyTableToolLoginProvidersCreate, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyDashboardWidgetDemoOpenAi, LazyDashboardWidgetGeneralTableIndex, LazyDashboardWidgetTradingDayAnalytics, LazyDashboardWidgetTradingIntervalAnalytics, LazyBasicHeading, LazyBasicText, LazySubheading, LazyPostLoader, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterString", LazyTableFilterString],
["TableToolBotsCreate", LazyTableToolBotsCreate],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolLoginProvidersCreate", LazyTableToolLoginProvidersCreate],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["DashboardWidgetDemoOpenAi", LazyDashboardWidgetDemoOpenAi],
["DashboardWidgetGeneralTableIndex", LazyDashboardWidgetGeneralTableIndex],
["DashboardWidgetTradingDayAnalytics", LazyDashboardWidgetTradingDayAnalytics],
["DashboardWidgetTradingIntervalAnalytics", LazyDashboardWidgetTradingIntervalAnalytics],
["BasicHeading", LazyBasicHeading],
["BasicText", LazyBasicText],
["Subheading", LazySubheading],
["PostLoader", LazyPostLoader],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
